import './Articles.css';
import React, { useRef } from 'react';
import { get, getTags, getDictionaryItem, getListingItemURL, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils'; // eslint-disable-line
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { injectImageResolution, pathJoin, getMediaHost } from '../../utils';
import getListing, { loadCategoryAlgoliaResults, isTagsRule } from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { generatrURLFromTags, getFeaturedItemAndList } from '../../utils';
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { generateSeeMoreTagsFromRules } from '../../utils/getListing';
import { useIsVisible } from '../../utils/useIsVisible';
import { convertToAnalyticObject } from '../../utils/analytics';

//type is coming from M31_News module

const baseImage = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
const setDateFormat = (date, lang) => {
  return new Date(date).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
const renderImage = (item, width, height, alt, imgClassName, bannerClickAnalytics, params, hostLink) => {
  if (!get(item, 'image')) return null;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), item.image])}`, width, height);
  return /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(bannerClickAnalytics, params), item.englishTitle),
    title: alt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: imgClassName,
    src: imgSrc,
    alt: alt,
    "aria-hidden": "true"
  })));
};
export const ArticleBlock = _ref => {
  let {
    item,
    copyBy,
    copyMinread,
    lang,
    hostLink,
    callback,
    analytics,
    removeDate = false,
    isListing = false
  } = _ref;
  const {
    eventsAnalytics,
    params
  } = analytics;
  return /*#__PURE__*/React.createElement("div", {
    className: `article article-item ${get(item, 'curators.curators.length') >= 1 ? 'has-no-curators' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small_image"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.8
  }, renderImage(item, 340, 243, item.title, 'small_image', eventsAnalytics['bannerClickAnalytics'], params, hostLink))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: item && item.objectID,
    callback: callback,
    classes: 'article__icon',
    componentPrimaryColor: 'var(--articles-theme-background-color)',
    componentPrimaryColorActive: "var(--articles-theme-background-active-color)",
    analyticsClick: e => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['addToFavAnalytics'], params), `${e}: ${item.englishTitle}`),
    isListing: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "article__content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, item.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.category), !removeDate && item.date && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, setDateFormat(item.date, lang)), item.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.location)), item.author && /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, item.author), item.title && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium article__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    openInSameTab: true,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), item.englishTitle)
  }, item.title))), item.authorImage && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__author"
  }, /*#__PURE__*/React.createElement("img", {
    className: "c-author__photo",
    src: baseImage + item.authorImage + '&cw=24&ch=24',
    alt: "Header"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-author__name"
  }, copyBy, " ", item.author), /*#__PURE__*/React.createElement("div", {
    className: "c-author__position"
  }))), item.readTime && item.readTime !== '0' && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: `label-small article__time`
  }, item.readTime, " ", copyMinread))));
};
export const Articles = _ref2 => {
  let {
    showNewsFeatured,
    type,
    params,
    fields,
    route
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const {
    isPersonalised
  } = sitecoreContext;
  const [searchResults, setSearchResults] = React.useState([]);
  const [validateItems, setValidateItems] = React.useState([]);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const theme = get(sitecoreContext, 'themesOfPage');
  const themePrimary = get(theme, 'primary') || '';
  const [isHidden, setIsHidden] = React.useState(undefined);
  const [styleThemeHexColor, setStyleThemeHexColor] = React.useState({});
  const currentLang = get(sitecoreContext, 'language');
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const parentId = get(fields, 'data.contextItem.parent.parentId', '').toLowerCase();
  const defaultTitle = getDictionaryItem(moduleDictionary, 'ArticlesTitle');
  const showFeatured = Boolean(get(fields, 'data.datasource.showFeatured.jss.value'));
  const searchCount = Number(get(params, 'SearchCount')) < 4 && showFeatured ? 5 : Number(get(params, 'SearchCount')) + 1;
  const discoverMoreField = get(fields, 'data.overviewButton.title.jss') || {
    value: 'Button'
  };
  const useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.value.href');
  const discoverMoreLink = useCustomListingPage ? listingPageLink : get(fields, 'data.overviewButton.link.jss.value.href');
  const headerTitle = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  const headerTitleValue = Boolean(get(headerTitle, 'value'));
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const ThemeBased = params !== undefined && params['Background Color'] === 'Theme Based' ? true : false;
  const GreyTheme = params !== undefined && params['Background Color'] === 'Grey' ? true : false;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  React.useEffect(() => {
    if (canUseDOM && document.body) {
      const ColorHex = get(params, 'ColorHex');
      const primaryColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
      const color = BackgroundColorHex ? ColorHex : getColorByTheme(selectedPrimaryColor);
      const activeColor = BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor;
      document.body.style.setProperty('--venue-table-background-color', primaryColor);
      document.body.style.setProperty('--venue-table-background-active-color', activeColor);
      document.body.style.setProperty('--venue-table-color', color);
      const styleThemeHexColorVar = ThemeBased ? {
        '--articles-theme-container-background-color': BackgroundColorHex ? BackgroundColorHex : primaryColor,
        '--articles-theme-hex-color': color,
        '--articles-theme-btn-hex-color': color,
        '--articles-theme-dots-hex-color': color,
        '--articles-theme-arrow-hex-color': activeColor,
        '--articles-theme-background-color': primaryColor,
        '--articles-theme-background-active-color': activeColor,
        '--articles-theme-text-color': color
      } : {
        '--articles-theme-container-background-color': GreyTheme ? '#EEEEEF' : '#fff',
        '--articles-theme-hex-color': '#000',
        '--articles-theme-btn-hex-color': primaryColor,
        '--articles-theme-dots-hex-color': '#505050',
        '--articles-theme-arrow-hex-color': primaryColor,
        '--articles-theme-background-color': primaryColor,
        '--articles-theme-background-active-color': activeColor,
        '--articles-theme-text-color': color
      };
      setStyleThemeHexColor(styleThemeHexColorVar);
    }
  }, [canUseDOM]);
  const itemType = type || 'articles';
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  //  const currentPageID =  "9d787bea237c40f4beb927c236c0cf8c"
  let dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  const contextItemId = get(fields, 'data.contextItem.id');
  let curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = `?curators.curators.Id=${contextItemId}`;
  }
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const BackColor = themePrimary ? 'brand-bg' : '';
  const indexName = get(params, 'SearchIndex');
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  // const [ref, inView] = useInView({ triggerOnce: false });
  const [isTriggered, setIsTriggered] = React.useState(false);
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const dictionary = get(fields, 'data.dictionary');
  const ReadNow = getDictionaryItem(moduleDictionary, 'ReadNow') || getDictionaryItem(dictionary, 'ReadMore');
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const typeArticle = type === 'news' ? '' : 'type:Article';
  const ref = useRef();
  const isVisible = useIsVisible(ref);
  const formatTagsRuleToFilters = function () {
    let withType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let facetsFilters = [withType && [typeArticle]];
    if (isTagsRuleUsed) {
      let parsedTR = JSON.parse(tagsRule);
      if (parsedTR.length) {
        parsedTR.forEach(rule => {
          facetsFilters.push(rule);
        });
      }
    }
    return facetsFilters;
  };
  const tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : [...datasourceTags];
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  const conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  const allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(condition => {
    const {
      handler,
      mappings
    } = condition;
    const conditionValues = handler.getValues({
      mappings,
      sitecoreContext
    });
    if (conditionValues) {
      allValues.push(...conditionValues);
    }
  });
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: searchResults,
    conditions: [algoliaScoredCondition(allValues)]
  });
  React.useEffect(() => {
    setSeeMoreURLTags(generatrURLFromTags(tagsList));
    if (isVisible) {
      if (isPersonalised && intentsLength) {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, typeArticle, searchCount, isTagsRuleUsed ? formatTagsRuleToFilters(false) : considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags], [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
          // setResults(hits);
          setSearchResults(hits);
          refreshTracking();
        })();
      } else {
        let filters = currentPageID ? `NOT objectID:${currentPageID}` : '';
        if (parentId) {
          filters = currentPageID ? `NOT objectID:${currentPageID} AND NOT objectID:${parentId}` : '';
        }
        let itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFilters(true) : [[typeArticle], considerPageLevelTags ? [...contextTags, ...itemTags] : [...itemTags]],
          // filters: currentPageID ? `NOT objectID:${currentPageID}` : '',
          filters
        };
        let results = [];
        let hiddenResults = '';
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          results.push(hits && hits.hits);
          results[0].map(result => {
            hiddenResults += ` AND NOT objectID:${result.objectID}`;
          });
          if (hits && hits.hits.length !== searchCount) {
            let itemFilter = {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: [typeArticle],
              filters: currentPageID ? ` (NOT objectID:${currentPageID} ${hiddenResults})` : ` (NOT objectID:${dummyId} ${hiddenResults})`
            };
            getListing(indexName, itemFilter, algoliaSettings).then(hits => {
              results.push(hits && hits.hits);
              let finalResults = results[0].concat(results[1]);
              finalResults.length ? setIsHidden(false) : setIsHidden(true);
              setSearchResults(finalResults);
            });
          } else {
            results[0].length ? setIsHidden(false) : setIsHidden(true);
            results[0] && setSearchResults(results[0]);
          }
        });
      }
    }
  }, [itemType, isPersonalised, isVisible]);
  let hasItems;
  if (intentsLength && isPersonalised) {
    hasItems = Boolean(personalizedList && personalizedList.length);
  } else {
    hasItems = Boolean(searchResults && searchResults.length);
  }
  let smallItems;
  let firstItems;
  if (intentsLength && isPersonalised) {
    const featuredItemList = hasItems && personalizedList && personalizedList.length > 1 ? getFeaturedItemAndList(personalizedList) : [];
    smallItems = featuredItemList.list;
    firstItems = personalizedList && get(featuredItemList.featured, 'item');
  } else {
    const featuredItemList = hasItems && searchResults.length > 1 ? getFeaturedItemAndList(searchResults) : [];
    smallItems = featuredItemList.list;
    firstItems = featuredItemList.featured;
  }
  const featured = Boolean(get(firstItems, 'featured')) && showFeatured;
  if (featured === false || showFeatured === false) {
    if (intentsLength && isPersonalised) {
      smallItems = personalizedList;
    } else {
      smallItems = searchResults;
    }
  }

  // if (!firstItems) {
  //   return <></>;
  // }

  const baseAuthorImgSrc = baseImage + get(firstItems, 'authorImage') + '&cw=24&ch=24';
  const renderTileItems = hostLink => {
    let itemsToMap = featured ? 4 : searchCount;
    return smallItems && smallItems.slice(0, itemsToMap).map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: `$article-carousel-tile-${index}`
    }, /*#__PURE__*/React.createElement(ArticleBlock, {
      item: item && item.item ? item.item : item,
      copyBy: mapDictionary.get('By'),
      copyMinread: mapDictionary.get('MinRead'),
      lang: currentLang,
      hostLink: hostLink,
      analytics: {
        eventsAnalytics,
        params
      }
    })));
  };
  const featuredItemWithColor = showFeatured === true && featured === true;
  React.useEffect(() => {
    setValidateItems(isPersonalised && intentsLength ? personalizedList : searchResults);
  }, [searchResults && searchResults.length, personalizedList && personalizedList.length]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    styleThemeHexColor: styleThemeHexColor,
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `${featured ? 'article article-multiple-featured' : ''} ${get(firstItems, 'curators.curators.length') >= 1 ? 'has-no-curators' : ''} m02-articles`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${featured ? 'article__featured' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `article ${!headerTitleValue && 'article-featured--no-heading'} article-featured ${featuredItemWithColor ? `article-featured--colour theme-hex-color` : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group-theme-1"
  }, showFeatured && featured === true && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    offset: 100,
    delay: 0
  }, /*#__PURE__*/React.createElement(Text, {
    className: `${showFeatured && featured === true ? 'h2 multipleTitle' : 'h3 article-title'}`,
    tag: "h4",
    field: headerTitle
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    offset: 300
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 col-xl-12 article-main-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-6 article-header-theme"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-header__image"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    openInSameTab: true,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), firstItems.englishTitle),
    title: firstItems.title
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: baseImage + firstItems.image + '&cw=720&ch=460'
  }), /*#__PURE__*/React.createElement("img", {
    className: "header_image",
    src: baseImage + firstItems.image + '&cw=460&ch=460',
    alt: firstItems.title
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-0 col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-lg-6 col-xl-5 article-content-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__content"
  }, firstItems && firstItems.authorImage && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.7
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__author"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "c-author__photo"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: baseAuthorImgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "c-author__photo",
    src: baseAuthorImgSrc,
    alt: "Author"
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-author__name"
  }, mapDictionary.get('By'), " ", firstItems.author), /*#__PURE__*/React.createElement("div", {
    className: "c-author__position"
  }, firstItems.authorRole))), hasItems && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__category"
  }, firstItems.category)), /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, firstItems.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, firstItems.category), firstItems.date && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, setDateFormat(firstItems.date, currentLang)), firstItems.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, firstItems.location)), firstItems.author && /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, firstItems.author), hasItems && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3 article__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    openInSameTab: true,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), firstItems.englishTitle)
  }, firstItems.title))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-content__text"
  }, firstItems.introText)), /*#__PURE__*/React.createElement("div", {
    className: "article__footer"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-link",
    openInSameTab: true,
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), firstItems.englishTitle)
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, ReadNow), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon "
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  }))), type !== 'news' && /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "btn-like__animation-item",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-like"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    componentPrimaryColor: 'var(--articles-theme-background-color)',
    componentPrimaryColorActive: "var(--articles-theme-background-active-color)",
    itemId: firstItems && firstItems.objectID,
    classes: 'article__icon',
    analyticsClick: e => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['addToFavAnalytics'], params), `${e}: ${firstItems.englishTitle}`),
    isListing: true
  }))))))))))))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `module-group article-multiple-group `
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 article__multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article article-multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__list row"
  }, showFeatured && featured === true && /*#__PURE__*/React.createElement("div", {
    className: "d-none d-lg-block col-lg-1 article__offset"
  }), /*#__PURE__*/React.createElement("div", {
    className: `col-md-12 col-xl-12 ${!(showFeatured && featured === true) ? 'remove-padding-mob' : ''}`
  }, showFeatured && featured === true && validateItems && validateItems.length > 0 || validateItems && validateItems.length > 0 && searchCount < 5 ? /*#__PURE__*/React.createElement(React.Fragment, null, !(showFeatured && featured === true) && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 h-title-x margin-changed"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    offset: 100,
    delay: 0
  }, /*#__PURE__*/React.createElement(Text, {
    className: `${showFeatured && featured === true ? 'h2 multipleTitle' : 'h3 article-title'}`,
    tag: "h4",
    field: headerTitle
  }))), ' '), /*#__PURE__*/React.createElement("div", {
    className: `article__items`
  }, renderTileItems(discoverMoreLink + curtorListingPage)), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "article-dots-wrapper__fadeInUp",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: `article__link ${!(showFeatured && featured === true) && searchCount < 5 ? 'margin-top' : ''}`
  }, discoverMoreField.value && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-secondary btn-mob",
    href: discoverMoreLink + curtorListingPage,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), discoverMoreField.value),
    title: `${headerTitle.value} - ${discoverMoreField.value}`
  }, discoverMoreField.value)))) : /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref3;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-12 h-title-x"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      offset: 100,
      delay: 0
    }, /*#__PURE__*/React.createElement(Text, {
      className: `${showFeatured && featured === true ? 'h2 multipleTitle' : 'h3 article-title'}`,
      tag: "h4",
      field: headerTitle
    })), /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params)))))), renderCarousel(renderTileItems(discoverMoreLink + curtorListingPage), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 4
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: 3
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "article-dots-wrapper"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "article-dots-wrapper__fadeInUp",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      delay: 200
    }, /*#__PURE__*/React.createElement("div", {
      className: "article__link"
    }, discoverMoreField.value && /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      className: "btn btn-secondary btn-mob",
      href: discoverMoreLink + curtorListingPage,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), discoverMoreField.value),
      title: `${headerTitle.value} - ${discoverMoreField.value}`
    }, discoverMoreField.value))), renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params)))));
  })), showFeatured && featured === true && /*#__PURE__*/React.createElement("div", {
    className: "d-none d-lg-block col-lg-2"
  }))))))))));
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    isHidden,
    anchorUrlParameter,
    styleThemeHexColor
  } = _ref4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles}  ${rtl ? rtlStyles : ltrStyles} ${ColorsLogic}`,
    style: styleThemeHexColor
  }, children) : null, ' ');
};
const ColorsLogic = "c1trmzp0";
const commonStyles = "c87gwmg";
const ltrStyles = "l1ghfigj";
const rtlStyles = "rmbflte";
export default Articles;